module.exports = __webpack_public_path__ + "static/Ashley-42e2d0d8beeca495a94262572fd4aaec.jpg";